import { types } from "../types/types";
const intitalState = {
    allAddOns: [],
};

const addOnReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.CHANGE_ADDON:
            return {
                ...state,
                allAddOns: action.payload,
            };
        default:
            return { ...state };
    }
};

export default addOnReducer;
